import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { deleteLeadPipelineStage } from '../api/leadPipelineStages';

export function useDeleteLeadPipelineStage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteLeadPipelineStage(id),
    onSuccess: () => {
      notification.success({ message: 'Pipeline stage deleted' });
      void queryClient.invalidateQueries({ queryKey: ['settings-lead-pipeline-stages'] });
      void queryClient.invalidateQueries({ queryKey: ['lead-pipeline'] });
    },
    onError: () => {
      notification.error({ message: 'Failed to delete pipeline stage' });
    },
  });
}
